import './Flag.bdaf5a6bb10d6d80df6dfc4ea9be4363.css';
export default {"flag":"_flag_1ha6p_1","border":"_border_1ha6p_1","withLabel":"_withLabel_1ha6p_1"};